import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CLINICAL_REVIEW_POA_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/ExpandedClinicalReviewPlanOfAction/List/ExpandedClinicalReviewPlanOfActionList.svelte"),
            title: "Expanded Clinical Review Plan of Action List"
        }
    ]
};

export default routerConfig;
